import styled from '@emotion/styled';

export const QualificationRequestContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex: 1;
  flex-wrap: no-wrap;
`;

export const QualificationRequestStepperContainer = styled.div`
  max-width: 25%;

  .back-button {
    margin-bottom: 40px;
    padding: 0px;
  }
`;

export const QualificationRequestStepContainer = styled.div`
  width: 75%;
  margin-left: auto;
`;
